const config = { 
  // baseURL: "https://app-dev.custodiy.com",
  baseURL: "https://custodiy.com",
  getAllNews: "news/getAllnews",
  coin_detail_base_url: "https://bscscan.com/address/contract_address/",
};
export default config;
